import { defineComponent as _defineComponent } from 'vue'
import { computed, isRef, useAttrs } from 'vue';
import SelectGroup from '../select/SelectGroup.vue';
import { SelectInputData } from './types';

interface SelectInputProps {
    data: SelectInputData;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectInput',
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as {
    data: SelectInputData;
};


const attrs = useAttrs();

const resolvedValue = computed<string | number>(() => {
    const current = props.data.value;
    return isRef(current) ? current.value as string | number : current;
});

const setValue = (value: string | number) => {
    const current = props.data.value;
    if (isRef(current)) {
        current.value = value;
        return;
    }
    props.data.value = value;
};

return { __sfc: true,props, attrs, resolvedValue, setValue, SelectGroup }
}

})